/**
 * Configuração central de contatos do Suporte.
 *
 * Altere os valores abaixo para mudar o destino dos botões de suporte.
 * Nenhum outro arquivo precisa ser editado.
 */

/** Número do WhatsApp em formato internacional, SOMENTE dígitos (DDI + DDD + número). */
export const SUPPORT_WHATSAPP_NUMBER = '5541999536187'

/** Mensagem pré-preenchida ao abrir o WhatsApp. */
const SUPPORT_WHATSAPP_MESSAGE =
  'Olá! Preciso de ajuda com a plataforma TITAM AI.'

/** E-mail de suporte. */
export const SUPPORT_EMAIL = 'deebsnow@gmail.com'

/** Assunto pré-preenchido do e-mail de suporte. */
const SUPPORT_EMAIL_SUBJECT = 'Suporte TITAM AI'

/** Corpo pré-preenchido do e-mail de suporte. */
const SUPPORT_EMAIL_BODY =
  'Olá, equipe TITAM AI!\n\nDescreva abaixo o problema, dúvida ou sugestão:\n\n'

/** Monta a URL wa.me com a mensagem pré-preenchida. */
export function buildWhatsAppUrl() {
  const digits = SUPPORT_WHATSAPP_NUMBER.replace(/\D/g, '')
  const text = encodeURIComponent(SUPPORT_WHATSAPP_MESSAGE)
  return `https://wa.me/${digits}?text=${text}`
}

/** Monta a URL mailto: com assunto e corpo pré-preenchidos. */
export function buildMailtoUrl() {
  const subject = encodeURIComponent(SUPPORT_EMAIL_SUBJECT)
  const body = encodeURIComponent(SUPPORT_EMAIL_BODY)
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`
}
